import { useQuery } from "@tanstack/react-query";
import { deleteServiceTemplate } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Update given serviceTemplate via RCB Service API.
 */ function useServiceTemplateDelete(id) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.deleteServiceTemplate(id), ({ signal })=>deleteServiceTemplate({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                id: String(id)
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: String(id)?.trim().length > 0 && !isNaN(Number(id))
    });
}
export { useServiceTemplateDelete };
